import { Title } from '@angular/platform-browser';
/***
 * 创建人：但志强
 * 时间：2019-06-11
 * 描述: 工作台的待办面板 显示前五条
 * 更新说明:
 */
import { Component, OnInit, ComponentFactoryResolver, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ProcessToDosService } from 'src/app/librarys/serves/public/process-to-dos.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { BdpEnum } from 'src/app/areas/bdp/serves/bdp-enum';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { ProjectManageService } from 'src/app/areas/apm/views/pm/project-manage.service';

/**
 * 工作台显示待办数据 默认显示前五条  sw-process-to-dos-table
 */
@Component({
  selector: 'sw-process-to-dos-table',
  templateUrl: './sw-process-to-dos-table.component.html',
  styleUrls: ['./sw-process-to-dos-table.component.css']
})
export class SwProcessToDosTableComponent implements OnInit {

  /**
   * @ignore
   * @param router
   * @param process
   */
  constructor(
    private router: Router,
    private process: ProcessToDosService,
    private Jwt: SwJwtService,
    private create: SwCreateModalComponentService,
    private cfr: ComponentFactoryResolver,
    private box: SwMassageBoxService, //消息服务
    private http: SwHttpClientService, //http 请求服务
    private systemId: SystemIdService,
    private projectManageService: ProjectManageService, // 请求项目管理服务
  ) { }

  /**
   * @ignore
   * 数据表基础信息
   */
  infoList: any = [];

  isLoading: boolean = true;
  /**
  * 输入属性--是否待办列表字段有更多按钮,默认有
  */
  @Input() hasMore: boolean = true

  /**
   * @ignore
   */
  ngOnInit() {
    this.getTask();
    this.infoList = []  //之前的 this.getTask() 的里面虽然已经获取到了待办列表,但是工作台刷新时,没有刷新效果,所以下面重新将 infoList 清空, 再调用 this.process.oninitToDoToDos() 方法,重新调接口获取待办,然后由 getTask() 中刷新数据
    this.process.oninitToDoToDos()
  }

  /**
   * 查看待办内容
   * @ignore
   */
  outSelectData(event) {
    //点击查看内容跳转到具体审核页面
    if (event.keyWord && event.businessId && event.url) {
      let param = {
        businessKey: event.keyWord + ":" + event.businessId,
        procInstId: event.procInstId,
        projectId: event.projectId
      };
      //接下来判断是用tab页打开还是模态框打开
      if (event.openType == 1) {
        //如果打开方式是 tab页 的话
        if (event.url == '/oa/DynamicFormRender') {
          this.router.navigate(['/oa/DynamicFormRender/' + event['formId']], { queryParams: { Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) } });
        } else {
          this.router.navigate([event.url], { queryParams: { Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) } });
        }
      } else if (event.openType == 2) {
        //如果是用模态框打开
        let fact = this.cfr["_factories"]
        //对参数进行处理
        let modalParam = event.params ? JSON.parse(event.params) : {}
        let queryParams = { Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) }
        let params = { param: modalParam, queryParams: queryParams }
        fact.forEach((value: any, key: any) => {
          if (value.selector == event.url) {
            this.create.createModal(key, params)
          }
        })
      } else {
        this.box.danger('没有打开方式' + event.openType)
      }
    }
  }



  /**
   * 获取所有待办信息前五条
   * @ignore
   */
  getTask() {
    this.process.oninitToDoToDos()
    this.process.oninitNotice()
    //首先 查看 初始化化方法是否以及获取到数据
    if (this.process.processList) {
      //如果获取到 则将数据赋值
      this.infoList = this.process.processList.records;
      this.getStatus();
    }
    //这是是待办的订阅属性
    this.process.processUpdated.subscribe((val) => {
      this.infoList = []
      //如果接受到数据
      //重新获取数据
      this.isLoading = false;
      this.infoList = val.records;
      this.getStatus();
    })
  }

  //处理标题显示
  showTitle(event) {
    if (event.length >= 12) {
      return event.substring(0, 10) + '..';
    } else {
      return event;
    }
  }

  index = 0
  //获取流程状态
  getStatus() {
    this.infoList.forEach(item => {
      item["projectStage"] = "待确认";
      item["flowStatus"] = "";

      //流程是新增基建项目-新或者基建发掘项目-新则查询对应状态数据
      if (item.keyWord == "APM_CONSTRUCTION_PROJECT_ADD_NEW" || item.keyWord == "APM_CONSTRUCTION_EXC_PROJECT_NEW") {
        item["type"] = "项目管理";

        let ids = { ids: [item.businessId] };  // 封装id
        this.projectManageService.queryProjectById(ids).subscribe(res => {
          if (res && res["code"] == 200 && res.data) {
            if (res.data.projectStage) {
              let projectStage = "";
              if (res.data.projectStage == 1) {
                projectStage = "调查阶段";
              }
              if (res.data.projectStage == 2) {
                projectStage = "勘探阶段";
              }
              if (res.data.projectStage == 3) {
                projectStage = "发掘阶段";
              }
              item["projectStage"] = projectStage;
              if (res.data.flowStatus) {
                item["projectStage"] = projectStage + "：";
                item["flowStatus"] = res.data.flowStatus;
              }

            }
          }
        })
      }

      //流程是安技防新流程
      if (item.keyWord == "APM_LEASE_CONTRACT_ADD_NEW" || item.keyWord == "APM_EXP_LEASE_CONTRACT_ADD_NEW") {
        item["type"] = "安技防";

        this.projectManageService.querySafetyTechApplicationById(item.businessId).subscribe(res => {
          if (res && res["code"] == 200 && res.data) {
            if (res.data.flowStatus) {
              item["projectStage"] = "";
              item["flowStatus"] = res.data.flowStatus;
              // 兼容历史勘探申请仍保存初始状态，但当前任务已是提交安装方案的记录。
              if (item.keyWord == "APM_EXP_LEASE_CONTRACT_ADD_NEW" && res.data.flowStatus == "APM2501"
                && item.userTaskName == "提交安装方案") {
                item["flowStatus"] = "APM2502";
              }
            }
          }
        })
      }

      //流程是发掘委托合同-新或者勘探委托合同-新流程
      if (item.keyWord == "APM_EXCAVATE_ENTRUST_CONTRACT" || item.keyWord == "APM_EXPLORATION_ENTRUST_CONTRACT") {
        item["type"] = "委托合同";
      }

      //流程是纸质资料移交（行政管理）或者纸质资料移交（田野考古）或者电子资料移交
      if (item.keyWord == "AAM_PAPER_ADMIN_ARCHIVE_ADD" || item.keyWord == "AAM_PAPER_FIELD_ARCHIVE_ADD" || item.keyWord == "AAM_ELE_ADMIN_ARCHIVE_ADD") {
        item["type"] = "档案管理";
      }

      item["endTimeStr"] = this.calculateTimeDifference(item.endTime);
      if (item.endTime) {
        item["isPast"] = item["endTimeStr"].includes('截止日期') ? "true" : "false";
      } else {
        item["isPast"] = "";
      }

    })
  }
  /**
   * 查看更多页面
   * @ignore
   */
  clickView() {
    this.router.navigate(['/oa/ToDoProcess'], { queryParams: { Title: '待办流程' } });
  }

  //显示截止日期
  calculateTimeDifference(dateString) {
    if (dateString) {
      const targetDate = this.parseDateString(dateString);
      const currentDate = new Date();
      const timeDiff = targetDate.getTime() - currentDate.getTime();

      const isPast = timeDiff < 0;
      const absoluteDiff = Math.abs(timeDiff);

      const formattedTime = this.formatTimeDifference(absoluteDiff);

      return isPast ? `已逾期：${formattedTime}` : `截止日期：${dateString}`;
    } else {
      return "";
    }
  }

  //解析 yyyy-MM-dd HH:mm 格式的日期字符串
  parseDateString(dateString: string): Date {
    const [datePart, timePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);

    return new Date(year, month - 1, day, hours, minutes);
  }

  //格式化时间差为 x天x小时x分钟 格式
  formatTimeDifference(milliseconds: number): string {
    const totalMinutes = Math.floor(milliseconds / (1000 * 60));
    const totalHours = Math.floor(totalMinutes / 60);

    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    const minutes = totalMinutes % 60;

    const parts: string[] = [];

    if (days > 0) {
      parts.push(`${days}天`);
    }

    if (hours > 0) {
      parts.push(`${hours}小时`);
    }

    if (minutes > 0 || parts.length === 0) {
      parts.push(`${minutes}分钟`);
    }

    return parts.join('');
  }

}
